import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CometChatUIKit } from "@cometchat/chat-uikit-react";
import { fetchMagic } from "./api";
import { setAny } from "./storage";

type Status = "loading" | "error" | "success";

export default function MagicPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [status, setStatus] = useState<Status>("loading");
  const [error, setError] = useState<string>("");

  const handleMagicLink = useCallback(async () => {
    const token = (searchParams.get("token") || "").trim();

    if (!token) {
      setError("Kein Token gefunden");
      setStatus("error");
      return;
    }

    try {
      const data = await fetchMagic(token);

      if (!data?.authToken) {
        throw new Error("Auth Token fehlt");
      }

      await CometChatUIKit.loginWithAuthToken(data.authToken);

      setAny(
        "tff_login",
        JSON.stringify({
          customerKey: data.customerKey,
          uid: data.uid,
          authToken: data.authToken,
          allowed: data.allowed,
          primaryModelUid: data.primaryModelUid || "",
          primaryModelName: data.primaryModelName || "",
          timestamp: Date.now(),
        })
      );

      setStatus("success");

      window.setTimeout(() => {
        navigate("/", { replace: true });
      }, 600);
    } catch (e: any) {
      setError(e?.message || "Login fehlgeschlagen");
      setStatus("error");
    }
  }, [searchParams, navigate]);

  useEffect(() => {
    void handleMagicLink();
  }, [handleMagicLink]);

  if (status === "loading") {
    return (
      <div className="app-container">
        <div className="loading-screen">
          <div className="loading-spinner"></div>
          <p>Melde dich an...</p>
        </div>
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="app-container">
        <div className="error-screen">
          <h2>Login fehlgeschlagen</h2>
          <p className="error-message">{error}</p>
          <button className="retry-button" onClick={() => navigate("/", { replace: true })}>
            Zurück
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="app-container">
      <div className="loading-screen">
        <h2 style={{ color: "#faa0bb" }}>✓ Erfolgreich angemeldet</h2>
        <p>Du wirst weitergeleitet...</p>
      </div>
    </div>
  );
}
